import { useMemo } from 'react';

import { type SelectOptionDefinition } from '@mui/base/useSelect/useSelect.types';
import { type OptionProp } from '@vakantiesnl/components/src/molecules/FilterList/FilterList.types';
import { DURATION_CONFIG_OPTIONS } from '@vakantiesnl/services/src/util/durations';
import { type MicroCopy } from '@vakantiesnl/types';

export const useParseDurationsFilterConfig = (microCopies: MicroCopy): OptionProp[] =>
	useMemo(() => {
		if (microCopies) {
			return Object.keys(DURATION_CONFIG_OPTIONS).map((key) => ({
				title: microCopies[`config.durations.label.${key}`],
				value: DURATION_CONFIG_OPTIONS[key as keyof typeof DURATION_CONFIG_OPTIONS].array.join(','),
			}));
		}
		return [];
	}, [microCopies]);

export const useParseDurationsFilterConfigLister = (microCopies: MicroCopy): SelectOptionDefinition<string>[] =>
	useMemo(() => {
		if (microCopies) {
			return Object.keys(DURATION_CONFIG_OPTIONS).map((key) => ({
				label: microCopies[`config.durations.label.${key}`],
				value: DURATION_CONFIG_OPTIONS[key as keyof typeof DURATION_CONFIG_OPTIONS].array.join(','),
			}));
		}
		return [];
	}, [microCopies]);
